import React from "react";
import PropTypes from "prop-types";
import { useLocalization } from "@fluent/react";
import Filters from "byzantine/src/filters";
import { useDocumentFilters } from "byzantine/src/dbbl/businessLogic/entities/documents/hooks";
import utils from "../../utils";
import Document from "./Document";
import FilterButton from "./FilterButton";

const DocumentList = ({ documentsJson, isHtmlJson }) => {
  const { l10n } = useLocalization();
  const documents = JSON.parse(utils.unescape(documentsJson));

  const {
    filteredDocuments,
    toggleActiveFilters,
    isFilterActive,
    filterChoices: { years, typeLabels },
  } = useDocumentFilters(documents);
  const noDocumentsDisplayedText =
    documents.length === 0
      ? l10n.getString("empty-documents", null, "No statements available.")
      : l10n.getString(
          "empty-filter-documents",
          null,
          "No documents match filters."
        );

  return (
    <div>
      <div className="padding--y--l">
        <h2>{l10n.getString("heading-statements")}</h2>
      </div>
      <div className="documents-page alignChild--left--top">
        <div>
          {years.length > 1 && (
            <div className="margin--bottom--m">
              <div className="margin--bottom--xs fontWeight--bold">
                {l10n.getString("label-filter-year", null, "Choose year")}
              </div>
              <div className="filter-list alignChild--left--center">
                {years.map((year) => (
                  <FilterButton
                    key={year}
                    filterName={year}
                    toggleActiveFilters={toggleActiveFilters.bind(
                      null,
                      "years",
                      year
                    )}
                    isActive={isFilterActive("years", year)}
                  />
                ))}
              </div>
            </div>
          )}
          {Object.keys(typeLabels).length > 1 && (
            <div className="margin--bottom--m">
              <div className="margin--bottom--xs fontWeight--bold">
                {l10n.getString("label-filter-type", null, "Choose type")}
              </div>
              <div className="filter-list alignChild--left--center">
                {Object.entries(typeLabels).map(([label, value]) => (
                  <FilterButton
                    key={value}
                    filterName={Filters.titlecase(label)}
                    toggleActiveFilters={toggleActiveFilters.bind(
                      null,
                      "typeLabels",
                      value
                    )}
                    isActive={isFilterActive("typeLabels", value)}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
        <div className="document-list">
          {filteredDocuments.length > 0 ? (
            filteredDocuments.map((d) => (
              <Document
                key={d.id}
                document={d}
                isHtml={JSON.parse(isHtmlJson)}
              />
            ))
          ) : (
            <div className="document-card">{noDocumentsDisplayedText}</div>
          )}
        </div>
      </div>
    </div>
  );
};
DocumentList.propTypes = {
  documentsJson: PropTypes.string.isRequired,
  isHtmlJson: PropTypes.oneOf(["true", "false"]).isRequired,
};

export default DocumentList;
